import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tEs from './locales/es.json';
import tEn from './locales/en.json';

const resources = {
    en: {
      translation: tEn,
    },
    es: {
      translation: tEs,
    },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    compatibilityJSON: 'v3',
    lng: "es",
    fallbackLng: 'es',
    resources,
    debug: false,
    returnNull:false,
    returnEmptyString:true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;
